/**
 * Adzuki
 * cpcentral_notifications.js
 */

(function CallTracker($, Adzuki)
{
	"use strict";

	var $modal  = $('.modal');

	$(document).ready(function documentReady()
	{
		$('.call-tracker-link').click(function _showCallTracker(e) {
			var agent_id = '';
			e.preventDefault();

			if ($(this).data('agent-id')) {
				agent_id = $(this).data('agent-id');
			}

			Adzuki.Ajax.get('/CallTrackerEntries/add/' + agent_id)
			.then(function _loadIt(response) {
				$modal.find('.modal-title').text("Agent Communication Tracker");
				$modal.find('.modal-body').html(response);
				$modal.modal('show');

				Adzuki.Form.initAjaxForm('CallTrackerEntry');
			});
		});
	});
}(jQuery, window.Adzuki || {}));